import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthDto } from './auth.dto';
import { AuthModel } from './auth.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private http: HttpClient = inject(HttpClient);
  private baseURL = environment.apiUrl;

  login(authModel: AuthModel): Observable<AuthDto> {
    return this.http.post(`${this.baseURL}/login`, authModel) as Observable<AuthDto>;
  }

  test(): Observable<AuthDto> {
    return this.http.get(`${this.baseURL}/test`) as Observable<AuthDto>;
  }

  logout() {
    return this.http.post(`${this.baseURL}/logout`, null) as Observable<AuthDto>;
  }
}
